
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import CollapseTruncateWrapper from '~/components/snippets/CollapseTruncateWrapper.vue'
import CollapseToggle from '~/components/snippets/CollapseToggle.vue'
import { OnMounted } from '~/core/vue.types'

@Component({
  components: {
    CollapseTruncateWrapper,
    CollapseToggle,
  },
})
export default class SeoContent extends Vue implements OnMounted {
  @Prop({
    required: false,
    type: String,
    default: '',
  })
  readonly id!: string

  @Prop({
    required: true,
    type: String,
  })
  readonly title!: string

  @Prop({
    required: true,
    type: String,
  })
  readonly content!: string

  @Prop({
    required: false,
    type: Boolean,
    default: false,
  })
  readonly collapsible!: boolean

  @Prop({
    required: false,
    type: Number,
    default: 450,
  })
  readonly collapsedHeight!: number

  @Prop({
    required: false,
    type: Boolean,
    default: true,
  })
  readonly expandedByDefault!: boolean

  @Prop({
    required: false,
    type: String,
    default: '',
  })
  readonly imageUrl!: string

  isExpanded = false

  get contentId (): string {
    if (this.id) {
      return this.id
    }

    return this.title.toLowerCase().trim().replace(/[^\w\d\s]+|\s/g, '-')
  }

  mounted () {
    if (!this.collapsible) {
      this.isExpanded = true

      return
    }

    this.isExpanded = this.expandedByDefault
  }
}
